<template>
  <div class="form-group">
    <label v-if="title">
      <span class="title">{{ title }}</span>
      <span
        class="required"
        v-if="required"
      >*</span>
      <Tip
        :field="field"
        :formName="formName"
      />
    </label>
    <div class="inner-addon right-addon">
      <vue-numeric
        :style="_style"
        class="form-control"
        v-on:keyup.enter.native="pressedEnter"
        :class="{ 'is-invalid': notifications.length > 0 && formDirty }"
        :placeholder="placeholder"
        :disabled="disabled"
        currency="R$"
        separator="."
        :minus="allowNegative"
        v-bind:precision="precision"
        v-model="valueLocal"
      >
      </vue-numeric>
      <span
        class="currency-icon"
        v-if="notifications.length == 0 || !formDirty"
      >
        <i class="fa-light fa-circle-dollar"></i>
      </span>
      <div
        class="required glyphicon"
        v-if="notifications.length > 0 && formDirty"
      >
        <i class="fas fa-exclamation-triangle"></i>
      </div>
    </div>
    <div v-if="formDirty">
      <div
        v-for="message in notifications"
        :key="message"
      >
        <span class="invalid">{{ message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Tip from "../shared/Tip.vue";
import VueNumeric from "vue-numeric";

import { mapState, mapMutations } from "vuex";

export default {
  name: "InputDecimal",
  mixins: [],
  props: {
    title: String,
    field: String,
    disabled: Boolean,
    placeholder: String,
    formName: String,
    _style: String,
    precision: {
      type: Number,
      default: 2,
    },
    markFormDirty: {
      type: Boolean,
      default: true,
    },
    allowNegative: {
      type: Boolean,
      default: false,
    },
    required: Boolean,
    value: Number,
    enter: Function,
  },
  components: {
    VueNumeric,
    Tip,
  },
  data() {
    return {
      notifications: [],
      formDirty: false,
      _value: 0,
      valueLocal: 20,
      isPrecision: false,
    };
  },
  created() {
    // não carregar as validações iniciais para number
    this.valueLocal = this.value;
  },
  methods: {
    ...mapMutations("validation", [
      "addValidation",
      "removeValidation",
      "updateFormDirty",
    ]),
    validate() {
      this.notifications = [];
      if (this.valueLocal == 0) return;
      if (this.required && !this.valueLocal) {
        var message = `${this.title} não pode ser vazio!`;
        this.notifications.push(message);
      }
    },
    pressedEnter() {
      if (this.enter) this.enter();
    },
  },
  computed: {
    ...mapState("validation", ["resetForm"]),
  },
  watch: {
    value() {
      this.valueLocal = this.value;
    },
    valueLocal() {
      this.validate();
      this.$emit("input", this.valueLocal);
      this.formDirty = true;
      if (this.markFormDirty) this.updateFormDirty(true);
    },
    notifications() {
      let self = this;
      this.notifications.forEach(function (notification) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
          notification: notification,
        };
        self.addValidation(obj);
      });

      if (this.notifications.length == 0) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
        };
        self.removeValidation(obj);
      }
    },
    resetForm: {
      handler(form) {
        if (form.name == this.formName) this.formDirty = false;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 14px !important;
  font-weight: 400 !important;
  color: #0a0a0a;
  letter-spacing: 0.5px !important;
}

.success {
  color: #94aa2a;
  font-size: 14px;
}

.invalid {
  color: #f0134d;
  font-size: 14px;
}

.currency-icon {
  color: #5f5f5f;
  font-size: 17px;
  position: absolute;
  right: 1px;
  top: 50%;
  transform: translateY(-50%);
  background: #f3f4f6;
  padding: 1px 12px;
  border-radius: 0 4px 4px 0;
}
</style>
